// src/pages/NotAuthorized.tsx
import React from "react";
import { Stack, Text, PrimaryButton } from "@fluentui/react";
import { useNavigate } from "react-router-dom";

const NotAuthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Stack verticalAlign="center" horizontalAlign="center" style={{ height: "100vh" }} tokens={{ childrenGap: 20 }}>
      <Text variant="xxLarge">🚫 アクセスが拒否されました</Text>
      <Text>このページを表示する権限がありません。</Text>
      <PrimaryButton text="ホームに戻る" onClick={() => navigate("/shokai")} />
    </Stack>
  );
};

export default NotAuthorized;
